<template>
    <div class="net-body net-order-pending" v-loading="loading">
        <div class="net-body-head">
            <div class="net-head-label">
                <div class="labelBox">
                    {{ item.label }}
                </div>
                <div class="updateTimeTip" v-show="NOPData.w_insert_dt">更新时间：{{NOPData.w_insert_dt}}</div>
            </div>
            <el-popover
                placement="bottom"
                trigger="hover"
                popper-class="net-workbench-pop"
            >
                <!-- <div class="net-popover-css" @click="tomoreFn">更多</div> -->
                <div class="net-popover-css" @click="closeUp(item.prop)">关闭</div>
                <i slot="reference" class="el-icon-more i-style"></i>
            </el-popover>
        </div>
        <div class="net-content">
            <ul class="net-box">
                <li class="box-item-full">
                    <div class="item-left">
                        <div>待派单</div>
                        <div class="HL-G">{{ NOPData.delivery_order_num }}</div>
                    </div>
                    <div class="item-right">
                        <el-button
                            type="text"
                            @click="checkData(jumpParam.delivery_order_num)"
                            >查看全部
                        </el-button>
                    </div>
                </li>

                <li class="box-item">
                    <div class="box-item-left">
                        <div class="item-left">
                            <div>待预约</div>
                            <div class="HL-G">
                                {{ NOPData.booking_order_num }}
                            </div>
                        </div>
                        <div class="item-right">
                            <el-button
                                type="text"
                                icon="el-icon-arrow-right"
                                @click="
                                    checkData(jumpParam.booking_order_num)
                                "
                            ></el-button>
                        </div>
                    </div>
                    <div class="box-item-right">
                        <div class="item-left">
                            <div>待派工</div>
                            <div class="HL-G">
                                {{ NOPData.dispatching_order_num }}
                            </div>
                        </div>
                        <div class="item-right">
                            <el-button
                                type="text"
                                icon="el-icon-arrow-right"
                                @click="
                                    checkData(jumpParam.dispatching_order_num)
                                "
                            ></el-button>
                        </div>
                    </div>
                </li>
                <li class="box-item">
                    <div class="box-item-left">
                        <div class="item-left">
                            <div>待审核</div>
                            <div class="HL-G">
                                {{ NOPData.review_order_num }}
                            </div>
                        </div>
                        <div class="item-right">
                            <el-button
                                type="text"
                                icon="el-icon-arrow-right"
                                @click="checkData(jumpParam.review_order_num)"
                            ></el-button>
                        </div>
                    </div>
                    <div class="box-item-right">
                        <div class="item-left">
                            <div>待用户签收</div>
                            <div class="HL-G">
                                {{ NOPData.pending_order_num }}
                            </div>
                        </div>
                        <div class="item-right">
                            <el-button
                                type="text"
                                icon="el-icon-arrow-right"
                                @click="checkData(jumpParam.pending_order_num)"
                            ></el-button>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import dayjs from 'dayjs';
import { getNetTablesInfo } from '../../../api/manaDesk.js';

export default {
    props: {
        item: {
            type: Object
        }
    },
    data() {
        return {
            loading: false,
            NOPData: {},
            startTime: dayjs().subtract(10, 'day').format('YYYY-MM-DD 00:00:00'),
            endTime: dayjs().format('YYYY-MM-DD 23:59:59'),
            jumpParam: {
                delivery_order_num: {
                    orderStatus: ['10', '20']
                },
                booking_order_num: {
                    orderStatus: ['100']
                },
                dispatching_order_num: {
                    orderStatus: ['120']
                },
                review_order_num: {
                    orderStatus: ['160', '170', '195', '300']
                },
                pending_order_num: {
                    KanbanStatus: '0'
                }
            }
        };
    },
    mounted() {
        this.getData();
    },
    methods: {
        async getData() {
            this.loading = true;
            const param = {
                type: 'cpkb_wdkb_dcldj',
                exportOrgId: "\"{'match_all':{}}\"",
                sourceType: 'es',
                nameMap: {
                    network_code: 'D20191223001',
                    network_center_code: 'D20201126001'
                },
                groupList: [
                    'network_code',
                    'network_center_code'
                ],
                logicalSymbolList: [
                    'or'
                ],
                refresh: true
            };
            await getNetTablesInfo(param).then(res => {
                if (res && res.code === '0') {
                    this.NOPData = {
                        dispatching_order_num: 0, // 待派单
                        booking_order_num: 0, // 待预约
                        delivery_order_num: 0, // 待派工
                        review_order_num: 0, // 待审核
                        pending_order_num: 0, // 待完结
                        w_insert_dt: ''
                    };
                    if (!res.data.length) return;
                    res.data.forEach(item => {
                        this.NOPData.dispatching_order_num += item.dispatching_order_num;
                        this.NOPData.booking_order_num += item.booking_order_num;
                        this.NOPData.delivery_order_num += item.delivery_order_num;
                        this.NOPData.review_order_num += item.review_order_num;
                        this.NOPData.pending_order_num += item.pending_order_num;
                        if (!this.NOPData.w_insert_dt && item.w_insert_dt) {
                            this.NOPData.w_insert_dt = item.w_insert_dt.split(' ')[1];
                        }
                    });
                }
            }).catch(() => {});
            this.$nextTick(() => {
                this.loading = false;
            });
        },
        // 跳转到网点任务管理页面
        checkData(params) {
            this.$router.push({
                query: {
                    ...params,
                    getData: true,
                    updateStartTime: this.startTime,
                    updateEndTime: this.endTime
                },
                path: '/net-task'
            });
        },
        closeUp() {
            this.$emit('closeUp', this.item.prop);
        },
        tomoreFn() {}
    }
};
</script>

<style lang="less">
.net-order-pending {
    .box-item {
        display: flex;
        color: #666;
        > div {
            width: 50%;
            display: flex;
            height: 85px;
            margin: 10px 10px 0 0;
            border-radius: 4px;
            // background-color: red;
            background-color: #f8f8f9;
            flex: 1;
        }
        .el-icon-arrow-right {
            font-weight: 800;
        }
        .item-left {
            margin-top: 20px;
            > div:first-child {
                height: 17px;
                line-height: 17px;
            }
            .HL-G {
                height: 25px;
                line-height: 25px;
            }
        }
    }
    .box-item-full {
        display: flex;
        margin-right: 10px;
        background-color: #f8f8f9;
        border-radius: 4px;
        .item-left {
            display: flex;
            > div:first-child {
                min-width: 36px;
                margin-right: 20px;
            }
        }
        > div {
            height: 45px;
            line-height: 45px;
        }
    }
    .item-left {
        padding-left: 20px;
        flex: 1;
        overflow: auto;
        > div:first-child {
            color: #666;
            font-size: 12px;
        }
        .HL-G {
            font-size: 18px;
            font-weight: 600;
            color: #00bcbf;
        }
    }
    .item-right {
        // width: 50px;
        .el-button {
            padding: 0 20px;
            height: 100%;
            font-size: 12px;
            color: #888;
            // transition: transform 0.25s ease;
            &:hover {
                color: #00bcbf;
                background: #ebfafa;
            }
        }
    }
}
</style>